'use strict';

angular.module('atex.dam').directive('wysiwyg', function () {
  return {
    require: '?ngModel',
    scope: false,

    link: function (scope, element, attrs, ngModel) {
      var ckEditor;

      scope.$on('dam:collection-hide-description', function (event) {
        if (ckEditor !== undefined && ckEditor.status === 'ready') {
          ckEditor.fire('blur');
          ckEditor.destroy();
        }
      });

      scope.$on('dam:collection-show-description', function (event) {
        var textAreaElement = element.find('textarea')[0];

        CKEDITOR.env.isCompatible = true;
        ckEditor = CKEDITOR.replace(textAreaElement);

        ckEditor.on('change', function () {
          element.find('textarea').scope().$data = ckEditor.getData();
          scope.$apply(function() {
            ngModel.$setViewValue(ckEditor.getData());
          });
        });
      });

    }
  };
});
